import React, { useState } from 'react'
import { Modal } from 'antd';
function TeachCheck(props) {
    const [open,setOpen] = useState(false)
    
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.bjc_name}
            </a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <h2>{props.bjc_name}</h2>              
                <p dangerouslySetInnerHTML={{__html:props.bjc_content}}></p>
            </Modal>
        </>
    )
}

export default TeachCheck